import RichTextDisplay from "@components/RichTextDisplay/RichTextDisplay";
import { shortCodesToReactComponents } from "@utilities/formatters/shortCodesToReactComponents";
import { useEffect } from "react";
import { useExistingUserEmail } from "../../context/existingUserEmail";
import styles from "./FormErrorMessage.module.scss";

export interface FormErrorMessageProps {
  text?: any;
  failedRichText?: any;
  failedTinyMceRichText?: any;
  userEmail?: string;
}

const FormErrorMessage = (props: FormErrorMessageProps) => {
  const { text, failedRichText, failedTinyMceRichText, userEmail = "" } = props;
  const { setExistingUserEmail } = useExistingUserEmail();

  useEffect(() => {
    if (userEmail) {
      setExistingUserEmail(userEmail);
    }
  }, [setExistingUserEmail, userEmail]);

  return (
    <div className={`${styles["error-message"]} field_error_msg`} role="alert">
      {text ? (
        <p>{shortCodesToReactComponents(text)}</p>
      ) : (
        <RichTextDisplay
          richText={failedRichText}
          tinyMceRichText={failedTinyMceRichText}
        />
      )}
    </div>
  );
};

export default FormErrorMessage;
